import { Suspense, lazy, useMemo, useCallback, memo } from "react"
import { useAppDispatch, useAppSelector } from "../../store"
import { setActiveLink } from "../../store/features/mainData/mainDataSlice"
import { Header } from "../Header"
import { Hero } from "../Hero"
import { useFormStepView } from "../../hooks/useFormStepView"
const Why = lazy(() => import("../Why").then(m => ({ default: m.Why })))
const ForWhat = lazy(() => import("../ForWhat").then(m => ({ default: m.ForWhat })))
const About = lazy(() => import("../About").then(m => ({ default: m.About })))
const Faq = lazy(() => import("../Faq").then(m => ({ default: m.Faq })))
const Footer = lazy(() => import("../Footer/Footer"))
// Закомментированные секции — раскомментировать при необходимости:
// const Review = lazy(() => import("../Review/Review"))
// const Banner = lazy(() => import("../Banner").then(m => ({ default: m.Banner })))
import { StateContainer } from "../../UI/StateContainer/StateContainer"
import { useSendScrollPosition } from "../../api/methods/sendUserAction/hooks"
import "./firstpage.sass"
import { Variants } from "../../configs/configs.types"

const contentRendering = (activeLink: string, setActiveLink: (event: string) => void) => {
  return (
    <>
      <Header activeLink={activeLink} />
      <main className="main">
        <Hero setActive={setActiveLink} />
        <Suspense fallback={null}>
          <Why />
        </Suspense>
        {/* <Suspense fallback={null}>
          <Banner />
        </Suspense> */}
        {/* <Suspense fallback={null}>
          <Review />
        </Suspense> */}
        <Suspense fallback={null}>
          <ForWhat setActive={setActiveLink} />
        </Suspense>
        <Suspense fallback={null}>
          <About />
        </Suspense>
        <Suspense fallback={null}>
          <Faq setActive={setActiveLink} />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer setActive={setActiveLink} />
      </Suspense>
    </>
  )
}

export const FirstPage = memo(() => {
  const dispatch = useAppDispatch()

  const {
    general: { isLoading, error, data }
  } = useAppSelector(state => state.configs)

  const variant = process.env.REACT_APP_VARIANT ?? Variants.v0

  const clickId = useAppSelector(state => state.userData.clickID)

  const { activeLink } = useAppSelector(state => state.mainData)

  useSendScrollPosition(clickId, "scroll_position")
  useFormStepView(0)

  const setActive = useCallback(
    (link: string) => {
      dispatch(setActiveLink(link))
    },
    [dispatch]
  )

  const content = useMemo(() => contentRendering(activeLink, setActive), [activeLink, setActive])
  const isInitialLoading = isLoading || (!data && !error)

  return (
    <div className={`first-page first-page__${variant}`}>
      {isInitialLoading && <StateContainer text="" />}
      {!isInitialLoading && error && <StateContainer text="" />}
      {!isInitialLoading && !!data && content}
    </div>
  )
})
